export default __webpack_public_path__ + "audio/ring.mp3";